package org.hs_soft.runmynesto.domain.model.home.media_center.tabs.media.add_tag


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import org.hs_soft.runmynesto.domain.model.general_error_model.GeneralError

@Serializable
data class AddTagModel(
    @SerialName("data")
    val `data`: Data?,
    @SerialName("errors")
    val errors: List<GeneralError?>?=null,
)